import type { FeatureFlags } from "../FeatureFlags";

export class StaticFeatureFlags<FeatureFlag extends string>
  implements FeatureFlags<FeatureFlag>
{
  private readonly featureFlags: Map<string, boolean>;
  private readonly fallback: boolean;

  constructor(
    featureFlags: { [key in FeatureFlag]: boolean },
    { fallback = false }: { fallback?: boolean } = {}
  ) {
    this.featureFlags = new Map(Object.entries(featureFlags));
    this.fallback = fallback;
  }

  isFeatureEnabled(feature: FeatureFlag): boolean {
    return this.featureFlags.get(feature) ?? this.fallback;
  }

  onFeatureFlagsUpdated(): void {
    // Do nothing
  }
}
